/* Inject sticky-bar button gradient styles after inline section styles so we win the cascade */
(function () {
  var s = document.createElement('style');
  s.textContent = [
    '@media screen and (max-width: 749px) {',
    '  .sticky-atc-bar__btn {',
    '    box-shadow: none !important;',
    '    background: transparent !important;',
    '    color: #fff !important;',
    '    background-image: linear-gradient(90deg, #ff6600, #ffaa00) !important;',
    '    background-size: 100% 100% !important;',
    '    transition: filter 0.25s ease, font-weight 0.2s ease !important;',
    '  }',
    '  .sticky-atc-bar__btn:hover:not([disabled]) {',
    '    filter: brightness(0.82) !important;',
    '    color: #fff !important;',
    '    font-weight: 700 !important;',
    '  }',
    '  .sticky-atc-bar__btn[disabled] {',
    '    box-shadow: none !important;',
    '  }',
    '}'
  ].join('\n');
  document.head.appendChild(s);
})();

if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      connectedCallback() {
        if (window.innerWidth >= 750) return;

        // Move to <body> before doing anything else.
        // product-info and its ancestors may have transforms that break
        // position:fixed. Appending to body escapes that containing block.
        // This triggers disconnect → reconnect, so guard with a flag.
        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
          return; // connectedCallback fires again after the move
        }

        this.inner = this.querySelector('.sticky-atc-bar__inner');
        this.stickyBtn = this.querySelector('.sticky-atc-bar__btn');
        this.btnText = this.querySelector('.sticky-atc-bar__btn-text');
        this.priceEl = this.querySelector('.sticky-atc-bar__price');
        this.sectionId = this.dataset.sectionId;

        this.mainBtn = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (!this.mainBtn || !this.inner) return;

        this._setupObserver();
        this._setupProxyClick();
        this._setupVariantSync();
      }

      disconnectedCallback() {
        this._observer?.disconnect();
        this._variantUnsubscriber?.();
      }

      _setupObserver() {
        this._observer = new IntersectionObserver(
          ([entry]) => {
            // Show only when the main button has scrolled above the viewport
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.inner.classList.toggle('is-visible', scrolledPast);
          },
          { threshold: 0 }
        );
        this._observer.observe(this.mainBtn);
      }

      _setupProxyClick() {
        this.stickyBtn.addEventListener('click', () => {
          if (this.stickyBtn.disabled) return;

          this.stickyBtn.classList.add('loading');
          this.stickyBtn.setAttribute('aria-disabled', 'true');

          // Delegate entirely to the main ATC button — product-form.js handles
          // the cart add, section re-render, and cart drawer open.
          this.mainBtn.click();

          this._waitForMainBtnReady();
        });
      }

      _waitForMainBtnReady() {
        const poll = setInterval(() => {
          const stillLoading = this.mainBtn.classList.contains('loading') ||
                               this.mainBtn.getAttribute('aria-disabled') === 'true';
          if (!stillLoading) {
            clearInterval(poll);
            this.stickyBtn.classList.remove('loading');
            this.stickyBtn.removeAttribute('aria-disabled');
          }
        }, 100);

        setTimeout(() => {
          clearInterval(poll);
          this.stickyBtn.classList.remove('loading');
          this.stickyBtn.removeAttribute('aria-disabled');
        }, 8000);
      }

      _setupVariantSync() {
        if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this._variantUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          ({ data }) => {
            if (data.sectionId !== this.sectionId) return;

            const variant = data.variant;
            if (!variant) {
              this._setUnavailable();
              return;
            }

            if (this.priceEl) {
              this.priceEl.textContent = this._formatMoney(variant.price);
            }

            if (variant.available) {
              this.stickyBtn.disabled = false;
              this.stickyBtn.removeAttribute('disabled');
              if (this.btnText) this.btnText.textContent = window.variantStrings?.addToCart || 'Add to cart';
            } else {
              this._setUnavailable();
            }
          }
        );
      }

      _setUnavailable() {
        this.stickyBtn.disabled = true;
        this.stickyBtn.setAttribute('disabled', '');
        if (this.btnText) this.btnText.textContent = window.variantStrings?.soldOut || 'Sold out';
      }

      _formatMoney(cents) {
        if (cents == null) return '';
        return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
      }
    }
  );
}
